import { ChangeDetectionStrategy, Component, input, output, signal } from '@angular/core';
import { Address, AddressProducts } from '@mwe/models';
import { isArrayWithOneItem } from '@mwe/utils';
import { NgbDropdown, NgbDropdownButtonItem, NgbDropdownItem, NgbDropdownMenu, NgbDropdownToggle } from '@ng-bootstrap/ng-bootstrap';
import { NgClass } from '@angular/common';
import { GetAddressPostCodeAndStreetPipe } from '@mwe/ui/pipes';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'mwe-address-with-selection-dropdown',
  templateUrl: './address-with-selection-dropdown.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgbDropdown,
    NgbDropdownToggle,
    NgClass,
    NgbDropdownMenu,
    NgbDropdownButtonItem,
    NgbDropdownItem,
    GetAddressPostCodeAndStreetPipe,
    TranslatePipe,
  ],
})
export class AddressWithSelectionDropdownComponent {
  address = input.required<Address>();
  addressOptions = input.required<AddressProducts[]>();

  newAddressSelected = output<AddressProducts>();
  isCollapsed = signal<boolean>(true);

  toggleDropDown(): void {
    if (isArrayWithOneItem(this.addressOptions())) {
      return;
    }

    this.isCollapsed.update(old => !old);
  }

  hideDropDown(): void {
    this.isCollapsed.set(true);
  }

  isAddressSelected(address: Address): boolean {
    return address.hashCode === this.address().hashCode;
  }

  onAddressSelected(addressProducts: AddressProducts): void {
    this.newAddressSelected.emit(addressProducts);
    this.isCollapsed.set(false);
  }
}
